import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

let deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  window.dispatchEvent(new Event("pwa-installable"));
});

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}

// Compact install button for headers/login.
export function InstallButton({ className = "" }) {
  const [canInstall, setCanInstall] = useState(!!deferredPrompt);
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    const on = () => setCanInstall(true);
    window.addEventListener("pwa-installable", on);
    return () => window.removeEventListener("pwa-installable", on);
  }, []);

  if (isStandalone()) return null;

  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      deferredPrompt = null;
      setCanInstall(false);
    } else if (isIOS()) {
      setIosHelp(true);
    }
  };

  if (!canInstall && !isIOS()) return null;

  return (
    <>
      <button data-testid="install-app-btn" onClick={install}
        className={`flex items-center gap-1.5 rounded-full bg-csh-orange px-3 py-2 text-xs font-bold text-white shadow-sm hover:scale-105 active:scale-95 transition-transform ${className}`}>
        <Download size={15} /> Install App
      </button>
      {iosHelp && (
        <div className="fixed inset-0 z-[120] flex items-end justify-center bg-black/60 p-4" onClick={() => setIosHelp(false)}>
          <div className="w-full max-w-sm rounded-3xl bg-white p-6 text-center" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setIosHelp(false)} className="ml-auto block"><X size={20} /></button>
            <h3 className="font-head text-2xl text-csh-blue">Install on iPhone/iPad</h3>
            <p className="mt-2 text-sm text-muted-foreground">Tap the <Share size={14} className="inline text-csh-purple" /> Share button in Safari, then choose <b>"Add to Home Screen"</b>.</p>
          </div>
        </div>
      )}
    </>
  );
}
